export interface CreateSetupIntentResponseDto {
  requiresAction: boolean;
  clientSecret: string;
  setupIntentId: string;
  error:
    | 'requires_payment_method'
    | 'requires_confirmation'
    | 'requires_action'
    | 'processing'
    | 'requires_capture'
    | 'canceled'
    | 'succeeded';
}
